/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../../utils/apiClient';
import { restructureSubscribeFormModel } from './restructuring';

class EventsUserNoticeSubscribeService {
  async getNoticeSubscribeByAuthUser() {
    const response = await api.get(
      '/events-user-notice-subscribe/user-notice-config/me',
      {}
    );
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: _.map(responseJson.data, item =>
        restructureSubscribeFormModel(item)
      )
    };
  }

  async setNoticeSubscribeByAuthUser(state, body) {
    const response = await api.post(
      '/events-user-notice-subscribe/user-notice-config/me',
      {},
      body
    );
    const responseJson = await response.json();
    return responseJson;
  }
}

export default new EventsUserNoticeSubscribeService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/events/services/EventsUserNoticeSubscribeService/EventsUserNoticeSubscribeService.js